export default "__VITE_ASSET__DwKp0cKt__$_?url__"